import * as React from 'react'
// Fuer die Translation
import { useI18next } from 'gatsby-plugin-react-i18next' 
import { graphql } from 'gatsby'
// Import von components
import Layout from '../../components/layout/layout'


const DatenschutzPage = () => {
  const {t} = useI18next();
    return (
      <Layout pageTitle='Datenschutz'>
        <div className="row">
        <div className="col-1"></div>
        <div className="col-9">

        <h2 class="wp-block-heading">Datenschutzerklärung</h2>



<p>Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt) werden von uns nur im Rahmen der Erforderlichkeit sowie zum Zwecke der Bereitstellung eines funktionsfähigen und nutzerfreundlichen Internetauftritts, inklusive seiner Inhalte und der dort angebotenen Leistungen, verarbeitet.</p>



<p>Gemäß <a href="http://dejure.org/gesetze/DSGVO/4.html" target="_blank" title="Art. 4 DSGVO: Begriffsbestimmungen">Art. 4 Ziffer 1</a>. der Verordnung (EU) 2016/679, also der Datenschutz-Grundverordnung (nachfolgend nur „DSGVO“ genannt), gilt als „Verarbeitung“ jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführter Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten, wie das Erheben, das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung.</p>



<p>Mit der nachfolgenden Datenschutzerklärung informieren wir Sie insbesondere über Art, Umfang, Zweck, Dauer und Rechtsgrundlage der Verarbeitung personenbezogener Daten, soweit wir entweder allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung entscheiden. Zudem informieren wir Sie nachfolgend über die von uns zu Optimierungszwecken sowie zur Steigerung der Nutzungsqualität eingesetzten Fremdkomponenten, soweit hierdurch Dritte Daten in wiederum eigener Verantwortung verarbeiten.</p>



<p>Unsere Datenschutzerklärung ist wie folgt gegliedert:</p>



<p>I. Informationen über uns als Verantwortliche<br />II. Rechte der Nutzer und Betroffenen<br />III. Informationen zur Datenverarbeitung</p>



<h3 class="wp-block-heading">I. Informationen über uns als Verantwortliche</h3>



<p>Verantwortlicher Anbieter dieses Internetauftritts im datenschutzrechtlichen Sinne ist:</p>



Linotech GmbH & Co.KG<br />Cord Grashorn<br />Euloer Strasse 242<br />03149 Forst<br />Deutschland




<p>Telefon: +49-3562-928997-0<br />Telefax: +49-3562-6985736<br />E-Mail: inf add linotech.de



</p><p>Datenschutzbeauftragte/r beim Anbieter ist:</p>



Cord Grashorn<br />Telefon: +49-3562-928997-0<br />E-Mail: E-Mail: inf add linotech.de



<h3 class="wp-block-heading">II. Rechte der Nutzer und Betroffenen</h3>



<p>Mit Blick auf die nachfolgend noch näher beschriebene Datenverarbeitung haben die Nutzer und Betroffenen das Recht</p>



<ul class="wp-block-list">
<li>auf Bestätigung, ob sie betreffende Daten verarbeitet werden, auf Auskunft über die verarbeiteten Daten, auf weitere Informationen über die Datenverarbeitung sowie auf Kopien der Daten (vgl. auch <a href="http://dejure.org/gesetze/DSGVO/15.html" target="_blank" title="Art. 15 DSGVO: Auskunftsrecht der betroffenen Person">Art. 15 DSGVO</a>);</li>



<li>auf Berichtigung oder Vervollständigung unrichtiger bzw. unvollständiger Daten (vgl. auch <a href="http://dejure.org/gesetze/DSGVO/16.html" target="_blank" title="Art. 16 DSGVO: Recht auf Berichtigung">Art. 16 DSGVO</a>);</li>



<li>auf unverzügliche Löschung der sie betreffenden Daten (vgl. auch <a href="http://dejure.org/gesetze/DSGVO/17.html" target="_blank" title="Art. 17 DSGVO: Recht auf Löschung (&quot;Recht auf Vergessenwerden&quot;)">Art. 17 DSGVO</a>), oder, alternativ, soweit eine weitere Verarbeitung gemäß <a href="http://dejure.org/gesetze/DSGVO/17.html" target="_blank" title="Art. 17 DSGVO: Recht auf Löschung (&quot;Recht auf Vergessenwerden&quot;)">Art. 17 Abs. 3 DSGVO</a> erforderlich ist, auf Einschränkung der Verarbeitung nach Maßgabe von <a href="http://dejure.org/gesetze/DSGVO/18.html" target="_blank" title="Art. 18 DSGVO: Recht auf Einschränkung der Verarbeitung">Art. 18 DSGVO</a>;</li>



<li>auf Erhalt der sie betreffenden und von ihnen bereitgestellten Daten und auf Übermittlung dieser Daten an andere Anbieter/Verantwortliche (vgl. auch <a href="http://dejure.org/gesetze/DSGVO/20.html" target="_blank" title="Art. 20 DSGVO: Recht auf Datenübertragbarkeit">Art. 20 DSGVO</a>);</li>



<li>auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der Ansicht sind, dass die sie betreffenden Daten durch den Anbieter unter Verstoß gegen datenschutzrechtliche Bestimmungen verarbeitet werden (vgl. auch <a href="http://dejure.org/gesetze/DSGVO/77.html" target="_blank" title="Art. 77 DSGVO: Recht auf Beschwerde bei einer Aufsichtsbehörde">Art. 77 DSGVO</a>).</li>
</ul>



<p>Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger, denen gegenüber Daten durch den Anbieter offengelegt worden sind, über jedwede Berichtigung oder Löschung von Daten oder die Einschränkung der Verarbeitung, die aufgrund der <a href="http://dejure.org/gesetze/DSGVO/16.html" target="_blank" title="Art. 16 DSGVO: Recht auf Berichtigung">Artikel 16</a>, <a href="http://dejure.org/gesetze/DSGVO/17.html" target="_blank" title="Art. 17 DSGVO: Recht auf Löschung (&quot;Recht auf Vergessenwerden&quot;)">17 Abs. 1</a>, <a href="http://dejure.org/gesetze/DSGVO/18.html" target="_blank" title="Art. 18 DSGVO: Recht auf Einschränkung der Verarbeitung">18 DSGVO</a> erfolgt, zu unterrichten. Diese Verpflichtung besteht jedoch nicht, soweit diese Mitteilung unmöglich oder mit einem unverhältnismäßigen Aufwand verbunden ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft über diese Empfänger.</p>



<p><strong>Ebenfalls haben die Nutzer und Betroffenen nach <a href="http://dejure.org/gesetze/DSGVO/21.html" target="_blank" title="Art. 21 DSGVO: Widerspruchsrecht">Art. 21 DSGVO</a> das Recht auf Widerspruch gegen die künftige Verarbeitung der sie betreffenden Daten, sofern die Daten durch den Anbieter nach Maßgabe von <a href="http://dejure.org/gesetze/DSGVO/6.html" target="_blank" title="Art. 6 DSGVO: Rechtmäßigkeit der Verarbeitung">Art. 6 Abs. 1 lit. f) DSGVO</a> verarbeitet werden. Insbesondere ist ein Widerspruch gegen die Datenverarbeitung zum Zwecke der Direktwerbung statthaft.</strong></p>



<h3 class="wp-block-heading">III. Informationen zur Datenverarbeitung</h3>



<p>Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt, der Löschung der Daten keine gesetzlichen Aufbewahrungspflichten entgegenstehen und nachfolgend keine anderslautenden Angaben zu einzelnen Verarbeitungsverfahren gemacht werden.</p>
<h4 class="jet-listing-dynamic-field__content">Allgemeine Verlinkung auf Profile bei Drittanbietern</h4><p>Der Anbieter setzt auf der Website eine Verlinkung auf die nachstehend aufgeführten sozialen Netzwerke ein.</p>
<p>Rechtsgrundlage ist hierbei <a href="http://dejure.org/gesetze/DSGVO/6.html" target="_blank" title="Art. 6 DSGVO: Rechtmäßigkeit der Verarbeitung">Art. 6 Abs. 1 lit. f DSGVO</a>. Das berechtigte Interesse des Anbieters besteht an der Verbesserung der Nutzungsqualität der Website.</p>
<p>Die Einbindung der Plugins erfolgt dabei über eine verlinkte Grafik. Erst durch einen Klick auf die entsprechende Grafik wird der Nutzer zu dem Dienst des jeweiligen sozialen Netzwerks weitergeleitet.</p>
<p>Nach der Weiterleitung des Kunden werden durch das jeweilige Netzwerk Informationen über den Nutzer erfasst. Dies sind zunächst Daten wie IP-Adresse, Datum, Uhrzeit und besuchte Seite. Ist der Nutzer währenddessen in seinem Benutzerkonto des jeweiligen Netzwerks eingeloggt, kann der Netzwerk-Betreiber ggf. die gesammelten Informationen des konkreten Besuches des Nutzers dem persönlichen Account des Nutzers zuordnen. Interagiert der Nutzer über einen „Teilen“-Button des jeweiligen Netzwerks, können diese Informationen in dem persönlichen Benutzerkonto des Nutzers gespeichert und ggf. veröffentlicht werden. Will der Nutzer verhindern, dass die gesammelten Informationen unmittelbar seinem Benutzerkonto zugeordnet werden, muss sich der Nutzer vor dem Anklicken der Grafik ausloggen. Zudem besteht die Möglichkeit, das jeweilige Benutzerkonto entsprechend zu konfigurieren.</p>
<p>Folgende soziale Netzwerke sind vom Anbieter verlinkt:</p>

<p><a href="https://www.generator-datenschutzerklärung.de" target="_blank" rel="noopener">Muster-Datenschutzerklärung</a> der <a href="https://www.bewertung-löschen24.de" rel="nofollow noopener" target="_blank">Anwaltskanzlei Weiß &amp; Partner</a></p>

          
        </div>
      </div>  
    </Layout> 
    )
}
  
export const Head = () => <title>Datenschutzerklärung</title>
  
  // Step 3: Export your component s
export default DatenschutzPage

export const query = graphql`
query ($language: String!) {
  locales: allLocale(
    filter: { ns: { in: ["datenschutz"] }, language: { eq: $language } }
  ) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;